import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_admin/admin/settings/lookups")({
  component: () => <Navigate to="/admin/settings" search={{ tab: "lookups" } as never} />,
});
